import { regFlow } from "@/constants/common";
import { EventTrackingProps } from "@/types/common";
import { Details } from "@/types/userDetails";
import { createContext, useContext } from "react";

export const RegistrationContext = createContext({
  details: {} as Details,
  setDetails: (details: any) => {},
  screenType: "",
  handleOnSubmit: (
    data?: any,
    nextAction?: string,
    trackingObj?: {},
    shouldSkipChangingScreenBeforeResumeParsing?: boolean,
  ) => {},
  translation: {} as any,
  handleEventTracking: (props: EventTrackingProps) => {},
  setToast: (toast: any) => {},
  progressPercent: 0,
  getNextAction: ({
    data,
    customCurrentStep,
    resumeUploaded,
    shouldSkipCheckingResumeParsing,
  }: {
    data?: any;
    customCurrentStep?: string;
    resumeUploaded?: boolean;
    shouldSkipCheckingResumeParsing?: boolean;
  } = {}) => {},
  isSkipabl: false,
  isLoading: false,
  isResumeUploaded: false,
  setIsResumeUploaded: (isResumeUploaded: boolean) => {},
  setIsLoading: (loading: boolean) => {},
  handleScreenChange: (
    nextAction: string,
    profileProgress?: number,
    isSkipabl?: boolean,
    data?: any,
  ) => {},
  isApp: false,
  initialIsMobile: false,
  flowType: regFlow,
  jobDetailUrlForSprWithId: "",
  hostname: "",
  timeLoader: 8000,
  userData: {} as any,
  setUserData: (data: any) => {},
});

export function useRegistrationProps() {
  return useContext(RegistrationContext);
}
